module.exports = __webpack_public_path__ + "static/media/new-londoner.05bd02a8.jpg";